let check=document.querySelector("[data-trigger-menu]");

$(document).ready(function () {
    $('window').on('load',function() {
        $('#stamped-reviews-widget').addClass('not-active');
        // $('.stamped-widget-button').attr({'tabindex':'0', 'role':'button'});


        $(document).off().on('click','.stamped-widget-button',function() {
            $('#stamped-reviews-widget').removeClass('not-active');
        });
    })

    
    $(document).on('keyup','modal-close',function(e) {
    if(e.which == 13 || e.key == "Enter") {
        $(this).trigger('click');
        $('modal-trigger').find('button').attr('aria-expanded','false');
    }
    });
    $(document).on('keyup','collection-active-filter',function(e) {
    if(e.which == 13 || e.key == "Enter") {
        $(this).trigger('click');
    }
    });

//    if($('[data-cart]').length) { 
//         let quantity=$('cart-counter').text()
//         let price=$('cart-total').text()
//         let label = 'Open cart with '+quantity+' items' + 'with a total value of ' + price
//         $('[data-cart]').attr('aria-label', label); 
//    }
   
   if($('.stamped-header-title').length) {
       let text=$('.stamped-header-title').text();
       $('.stamped-header-title').replaceWith('<h2>'+text+'</h2>'); 
    }

    if($('[data-cart-notification]').length) {
        $('[data-cart-notification]').closest('dialog').attr('aria-label','Product added to cart overview');

    }

    // $(window).on('load',function() {

    //     $('main').find('iframe').each(function() {

    //        let attrURL=$(this).attr('src');

    //        if(attrURL.includes('?')) {
    //         attrURL=attrURL.split('?')[0]
    //         attrURL='[yt-url="'+attrURL+'"]'
    //         if($(attrURL).length) {
    //             let text=$(attrURL).next('p').text();

    //             $(this).after('<div></div>');
    //             $(this).next('div').addClass('video-transcript').html('<button>Show Transcript</button>').append('<p>'+text+'</p>');

    //             $(this).next('.video-transcript').find('p').slideUp();

    //             $(this).next('.video-transcript').find('button').on('click',function() {
    //                 $(this).next('p').slideToggle();
    //             });
    //         }
    //     }
    //         else {
    //             attrURL='[yt-url="'+attrURL+'"]'
    //             if($(attrURL).length) {
    //                 let transcriptHtml=$(attrURL).next('[transcript]').html();
    //                 $(this).parent().addClass('video-transcript-wrapper');
    //                 $(this).after('<div></div>');
    //                 $(this).next('div').addClass('video-transcript').html('<button>Show Transcript</button><div></div>')
    //                 $(this).next('.video-transcript').find('div').html(transcriptHtml)
    //                 $(this).next('.video-transcript').find('div').slideUp();
    //                 $(this).next('.video-transcript').find('button').on('click',function() {
    //                     $(this).next('div').slideToggle();
    //                 });
    //             }
    //         }

    //     })        
    // })
});